import { LiveCallsDefault } from '../components/features'

const LiveCalls = () => {
  return (
    <LiveCallsDefault/>
  )
}

export default LiveCalls
